import { Pipe, PipeTransform } from '@angular/core';
import { PROVISIONING_STATE_UI } from 'src/app/model/provisioning-state-ui';

@Pipe({
  name: 'provisioningState'
})
export class ProvisioningStatePipe implements PipeTransform {
  transform(value: number | null | undefined) {
    if (value === null || value === undefined) {
      return {
        text: '-',
        class: 'badge-light',
        icon: ''
      };
    }
    
    return PROVISIONING_STATE_UI[value] || {
      text: '',
      class: 'badge-light',
      icon: ''
    };
  }
}